import { useState } from 'react';
import styles from '../EditarPaso.module.css';
import {
    FaArrowLeft,
} from 'react-icons/fa';
import Swal from 'sweetalert2';
import img1 from './images/Valores.png';
import img2 from './images/Logro.png';
import img3 from './images/Autoestima.png';
import img4 from './images/Becas_vigentes.png';
import img5 from './images/FORMATO.png';
import img6 from './images/IMAGEN.png';
import img7 from './images/PRESENTACION.png';
import img8 from './images/Personalidad.png';
import img9 from './images/Solicitar_beca.png';
import img10 from './images/Test.png';
import img11 from './images/Tipos_becas.png';
import img12 from './images/VIDEO.png';
import {useAuth} from '../../../Auth/AuthContext'; 

const NuevaSeccion = ({pasoId, tipoArchivo, plantillaId, plantillaNombre,onVolver, onGuardar}) => {
    const [formData, setFormData] = useState({
        se_nombre: '',
        se_icono: '',
        se_descripcion: '',
        se_url: '',
        se_archivo: null
    });

    const {getToken} = useAuth(); 
    const token = getToken(); 

    const images = [
        { label: 'Valores', src: img1, name: 'Valores.png' },
        { label: 'Logro', src: img2, name: 'Logro.png' },
        { label: 'Autoestima', src: img3, name: 'Autoestima.png' },
        { label: 'Becas vigentes', src: img4, name: 'Becas_vigentes.png' },
        { label: 'Formato', src: img5, name: 'FORMATO.png' },
        { label: 'Imagen', src: img6, name: 'IMAGEN.png' },
        { label: 'Presentación', src: img7, name: 'PRESENTACION.png' },
        { label: 'Personalidad', src: img8, name: 'Personalidad.png' },
        { label: 'Solicitar beca', src: img9, name: 'Solicitar_beca.png' },
        { label: 'Test', src: img10, name: 'Test.png' },
        { label: 'Tipos becas', src: img11, name: 'Tipos_becas.png' },
        { label: 'Video', src: img12, name: 'VIDEO.png' },
    ];

    const componentes = [
        { label: 'Areas Profesionales', arc: 'AreasProfesionales', name: 'Areas Profesionales'},
        { label: 'Directorio de Universidades', arc: 'DirectorioUniversidades', name: 'Directorio de Universidades'},
        { label: 'Becas Vigentes', arc: 'BecasVigentes', name: 'Becas Vigentes'},
        { label: 'Videos y Recorridos Virtuales', arc: 'VideosRecorridos', name: 'Videos y Recorridos Virtuales'}
    ];

    const [errors, setErrors] = useState({});
    const [error, setError] = useState('');
    const [saving, setSaving] = useState(false);
    const [selected, setSelected] = useState(null);
    const [selectedComp, setSelectedComp] = useState(null);

    const handleInputChange = (e) => {
        const {name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if(errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFormData(prev => ({
            ...prev,
            se_archivo: file
        }));
        if(errors.se_archivo) {
            setErrors(prev => ({
                ...prev,
                se_archivo: ''
            }));
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.se_nombre.trim() || !formData.se_descripcion.trim() || !selected) {
            setError('Todos los campos son obligatorios');
            return;
        }

        const selectedImage = images[selected];
        const imageName = selectedImage.name;

        setSaving(true);
        setError('');
        setErrors({});

        try {
            let response;

            if (tipoArchivo === 'Componente') {
                const selectedC = componentes[selectedComp];
                const componArc = selectedC.arc;

                const formDataToSend = new FormData();
                formDataToSend.append('se_nombre', formData.se_nombre);
                formDataToSend.append('se_icono', imageName); // puedes enviarlo como string también
                formDataToSend.append('se_descripcion', formData.se_descripcion);
                formDataToSend.append('se_url', componArc);
                formDataToSend.append('se_archivo', formData.se_archivo || '');
                formDataToSend.append('se_tipo_archivo', tipoArchivo);
                formDataToSend.append('pasoId', pasoId);

                response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/crear-seccion`, {
                    method: 'POST',
                    headers: {
                    'Authorization': `Bearer ${token}`,
                },
                    body: formDataToSend
                });
            } else if (tipoArchivo === 'PDF' || tipoArchivo === 'Ejercicio') {
                const formDataToSend = new FormData();
                formDataToSend.append('se_nombre', formData.se_nombre);
                formDataToSend.append('se_icono', imageName); // puedes enviarlo como string también
                formDataToSend.append('se_descripcion', formData.se_descripcion);
                formDataToSend.append('se_url', formData.se_url || '');
                formDataToSend.append('se_archivo', formData.se_archivo);
                formDataToSend.append('se_tipo_archivo', tipoArchivo);
                formDataToSend.append('pasoId', pasoId);

                response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/crear-seccion`, {
                    method: 'POST',
                    headers: {
                    'Authorization': `Bearer ${token}`,
                    },
                    body: formDataToSend
                });
            } else {
                const dataToSend = {
                    se_nombre: formData.se_nombre,
                    se_icono: imageName,
                    se_descripcion: formData.se_descripcion,
                    se_url: formData.se_url || null,
                    se_archivo: formData.se_archivo || null,
                    pasoId: pasoId,
                    se_tipo_archivo: tipoArchivo
                };
                response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/crear-seccion`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(dataToSend)
                });
            }
            if (!response.ok) {
                const text = await response.text();
                
                try {
                    const errorData = JSON.parse(text);
                    Swal.fire({
                        title: 'Error al crear sección',
                        text: "Solo se permiten archivos PDF",
                        icon: 'error',
                        confirmButtonText: 'Entendido',
                        confirmButtonColor: '#242b57',
                        customClass: {
                            popup: 'popupbonito',
                        },
                    });
                    setError(errorData.message || 'Error al crear el sección');
                } catch (parseError) {
                    console.error('No es JSON válido:', text);
                    Swal.fire({
                        title: 'Error de conexión',
                        text: 'No se pudo conectar con el servidor',
                        icon: 'error',
                        confirmButtonColor: '#242b57',
                        customClass: {
                            popup: 'popupbonito',
                        },
                    });
                    setError('Error del servidor');
                }
                return;
            }
            
            const data = await response.json();
            Swal.fire({
                title: '¡Sección creada!',
                text: data.message || 'La sección se ha creado correctamente',
                icon: 'success',
                confirmButtonText: 'Continuar',
                confirmButtonColor: '#242b57',
                customClass: {
                    popup: 'popupbonito',
                },
                timer: 3000,
            }).then(() => {
                setFormData({
                    se_nombre: '',
                    se_descripcion: '',
                    se_url: '',
                    se_archivo: null
                });
                onGuardar && onGuardar();
            });
            
        } catch (err) {
            setError('Error al guardar la sección. Intenta nuevamente.');
            console.error('Error:', err);
        } finally {
            setSaving(false);
        }
    }
    
    const getTipoTexto = () => {
        switch (tipoArchivo) {
            case 'URL':
                return 'URL de Presentación';
            case 'Video':
                return 'Video de Drive';
            case 'PDF':
                return 'Presentación PDF';
            case 'Ejercicio':
                return 'Ejercicio Descargable';
            case 'Componente':
                return 'Elemento Cargado';
            default:
                return 'Nueva Sección';
        }
    };

    const getPlaceholderUrl = () => {
        switch (tipoArchivo) {
            case 'URL':
                return 'https://ejemplo.com/presentacion';
            case 'Video':
                return 'https://drive.google.com/file/d/...';
            default:
                return 'https://ejemplo.com';
        }
    };

    return (
        <div className={styles.formContainerPaso}>
            <div className={styles.headerSection}>
                <button className={styles.btnBack} onClick={onVolver}>
                    <FaArrowLeft className={styles.flechaVolver} />
                    Volver al paso
                </button>
                <h1 className={styles.titulo}>Crear {getTipoTexto()}</h1>
            </div>

            {/* Contenido principal */}
            <form onSubmit={handleSubmit} className={styles.pasoForm}>
                    <div className={styles.formBody}>
                        <div className={styles.formSection}>
                            <h3>Información de la Sección</h3>
                            <div className={styles.formEdit}>
                                <label htmlFor="se_nombre">
                                    Título de la sección
                                </label>
                                <input
                                    type="text"
                                    id="se_nombre"
                                    name="se_nombre"
                                    value={formData.se_nombre}
                                    onChange={handleInputChange}
                                    placeholder="Ej. Aprendizajes de mí"
                                    required
                                />
                                {errors.se_nombre ? styles.error : ''}
                            </div>

                            <div className={styles.formEdit}>
                                <label htmlFor="se_descripcion">
                                    Descripción
                                </label>
                                <textarea
                                    id="se_descripcion"
                                    name="se_descripcion"
                                    value={formData.se_descripcion}
                                    onChange={handleInputChange}
                                    placeholder="Describe el contenido de esta sección"
                                    rows={4}
                                    required
                                />
                                {errors.se_descripcion ? styles.error : ''}
                            </div>
                        </div>

                        <div className={styles.formSection}>
                            <h3>Diseño de Sección</h3>
                            {(tipoArchivo === 'URL' || tipoArchivo === 'Video') && (
                                <div className={styles.formEdit}>
                                    <label htmlFor="se_url">
                                        {tipoArchivo === 'Video' ? 'URL del video ' : 'URL del enlace '}
                                    </label>
                                    <input
                                        type="url"
                                        id="se_url"
                                        name="se_url"
                                        value={formData.se_url}
                                        onChange={handleInputChange}
                                        placeholder={getPlaceholderUrl()}
                                        required
                                    />
                                    {errors.se_url ? styles.error : ''}
                                    {errors.se_url && <span className={styles.errorSeccion}>{errors.se_url}</span>}
                                </div>
                            )}

                            {(tipoArchivo === 'PDF' || tipoArchivo === 'Ejercicio') && (
                                <div className={styles.formEdit}>
                                    <label htmlFor="se_archivo">
                                        {tipoArchivo === 'pdf' ? 'Selecciona un archivo PDF ' : 'Subir archivo '}
                                    </label>
                                    <input
                                        type="file"
                                        id="se_archivo"
                                        name="se_archivo"
                                        onChange={handleFileChange}
                                        accept={tipoArchivo === 'pdf' ? '.pdf' : '*'}
                                    />
                                    {errors.se_archivo ? styles.error : ''}
                                    {formData.se_archivo && (
                                        <p className={styles.fileInfo}>
                                            Archivo seleccionado: {formData.se_archivo.name}
                                        </p>
                                    )}
                                    {errors.se_archivo && <span className={styles.errorSeccion}>{errors.se_archivo}</span>}
                                </div>
                            )}

                            {(tipoArchivo === 'Componente') && (
                                <div className={styles.formEdit}>
                                        <select onChange={(e) => setSelectedComp(e.target.value)}>
                                            <option value="">Selecciona una opción</option>
                                            {componentes.map((comp, index) => (
                                                <option key={index} value={index}>{comp.label}</option>
                                            ))}
                                        </select>
                                </div>
                            )}

                            <div className={styles.formEdit}>
                                    <select onChange={(e) => setSelected(e.target.value)}>
                                        <option value="">Selecciona una opción</option>
                                        {images.map((img, index) => (
                                            <option key={index} value={index}>{img.label}</option>
                                        ))}
                                    </select>

                                    {selected !== "" && selected !== null && images[selected] && (
                                        <div>
                                            <img 
                                                src={images[selected].src} 
                                                alt={images[selected].label} 
                                                style={{ width: '100%' }} 
                                            />
                                        </div>
                                    )}
                                </div>
                        </div>
                    </div>

                    <div className={styles.formActions}>
                        <button 
                            type="submit" 
                            className={styles.btnSubmit}
                        >
                            Crear Sección
                        </button>
                    </div>
                </form>
        </div>

    );
};

export default NuevaSeccion;